import React from 'react';
import {
  Row,
  RowRendererProps as DataGridRendererProps,
} from 'react-data-grid';
import { useNavigate } from 'react-router-dom';
import { BodyRow } from 'app/components/ChakraTableList/types';
import { ContextMenuOption } from 'types/general.types';
import { Tooltip } from '@chakra-ui/react';

interface RowRendererProps extends DataGridRendererProps<BodyRow> {
  customRowRenderer?: (
    props: DataGridRendererProps<BodyRow>
  ) => React.ReactElement;
  setOptions: React.Dispatch<React.SetStateAction<ContextMenuOption[] | null>>;
  setPosition: React.Dispatch<
    React.SetStateAction<{ x: number; y: number } | null>
  >;
}

export const RowRenderer: React.FC<RowRendererProps> = ({
  customRowRenderer,
  setOptions,
  setPosition,
  ...props
}) => {
  const navigate = useNavigate();
  const shouldTriggerContext = Boolean(props.row?.rowData?.options);
  const onContextMenu = (e: React.MouseEvent<HTMLDivElement>) => {
    if (shouldTriggerContext) {
      setOptions(props?.row?.rowData?.options || null);
      const x = e.clientX;
      const y = e.clientY;
      setPosition({ x, y });
    }
    e.preventDefault();
  };
  const { to, ...row } = props.row;
  const extendedProps = {
    ...props,
    ...(to
      ? {
          onClick: () => {
            const path = typeof to === 'string' ? to : to.path;
            const state = typeof to === 'string' ? {} : to?.state;
            navigate(path, { state });
          },
        }
      : {}),
    onContextMenu: shouldTriggerContext ? onContextMenu : undefined,
  };
  const rowContent = customRowRenderer ? (
    customRowRenderer(extendedProps)
  ) : row.tooltip ? (
    <Tooltip
      label={row.tooltip}
      closeOnPointerDown={false}
      closeOnClick={false}
    >
      <Row {...extendedProps} />
    </Tooltip>
  ) : (
    <Row {...extendedProps} />
  );

  return rowContent;
};
